import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface SwithButton {
  id: string | number;
  text: string;
  notification?: string | number;
  disabled: boolean;
  value?: string;
}

@Component({
  standalone: false,
  selector: 'ti-swith-buttons-input',
  templateUrl: 'swith-buttons-input.component.html',
  styleUrls: ['swith-buttons-input.component.sass'],
})
export class SwithButtonsInputComponent {
  miscStrings = tiStrings.app.misc;

  @Input() buttons: SwithButton[];
  @Input() active: string;
  @Output() activeChange = new EventEmitter<string>();

  toggle(e, button: string) {
    e.preventDefault();
    if (button !== this.active) {
      this.active = button;
      this.activeChange.emit(button);
    }
  }
}
